import Nav from '../components/Nav';
import heroimageS from "../assets/images/small/Nadine&JP-136.webp"
import heroimageL from "../assets/images/big/Nadine&JP-136.jpg"

import Hero from '../components/Hero';
import {
  Box,
  Grid,
  Container,
  Typography,
} from '@mui/material';
import { Circle } from '../components/Circle';

const principalSponsors = [
  "Mr. Sergio Baccol",
  "Mrs. Pablita Baccol",
  "Mr. Godfrey Driscoll",
  "Mrs. Eladia G. Dela Cruz",
  "Mr. Alex Iskandar Liew",
  "Ms. Sally J. Defensor",
  "Mrs. Julie Rose T. Defensor",
  "Mr. Michael T. Defensor",
  "Engr. Jode Joloro Defensor",
  "Mrs. Marjorie Anne Ramos Defensor",
  "Mr. Manuel Pechay",
  "Mrs. Rosabella Pechay",
  "Mr. Ramon Cuison",
  "Mrs. Menchie Q. Añonuevo",
  "Mr. Edgar R. Santiago",
  "Mrs. Dolores G. Villanueva",
  "Mr. Stanley King",
  "Mrs. Corazon B. Sanchez King",
  "Dr. Carmelo I. Alcantara",
  "Mrs. Regina S. Alcantara",
  "Mr. Jesus Franco Caldelero",
  "Mrs. Teresita G. Adao",
  "Dr. Lawrence S. Gamboa",
  "Mrs. Leticia Corpus",
  ];

const candle = ["Mr. Leon Jala", "Mrs. Andrea Jala"];

const veil = ["Mr. Mathew Larin", "Mrs. Christine R. Larin"];

const cord = ["Mr. Ferdie Bautista","Mrs. Gigit Bautista"];

const bestMan = ["Ernesto David Jr.", "Bryan Custodio"];

const maidOfHonor = ["Marla Mae Gravador Defensor", "Greta Joloro Defensor"];

const groomsmen = ["Mark Defensor", "Philip Manahan", "Karl Daiwey", "Gene Del Mundo", "Karlo Jay Barra"];

const bridesmaids = ["Erika Bautista", "Priscilla Kiyohara", "Catherine Marapao", "Lara Mae Dela Cruz", "Elaine Defensor"];

const juniorGroomsmen = ["Lionne Gabrielle Q. Custodio", "Niegel Zach Defensor"];

const juniorBridesmaids = ["Shalee Mae Defensor", "Princess Concepcion"];

const bearers = ["Ethan Jacob Malapit", "Abel Bruce Custodio", "Gil D. Carmona III"];

const flowerGirls = ["Katherina Olivia D. Marapao", "Gillaine D. Carmona", "Peregrine Baconawa Bautista"];

function Roles(props) {
  let columns = 6;
  if (props.col === 3) {
    columns = 4;
  }
  return (
    <Grid item xs={12} lg={columns}>
      <Typography variant="h3" sx={{ textAlign: {xs: 'center', lg: 'left'}}} pt={{xs: "1.5em", lg: 0}}>{props.title}</Typography>
      {props.content.map(i =><Typography variant="body1" pb="0.25em" sx={{ textAlign: {xs: 'center', lg: 'left'}}}>{i}</Typography>)}
    </Grid>
  )
}

export default function Entourage() {
  return (
    <Box className="entourage">
      <Nav />
      <Hero name="ENTOURAGE" imageS={heroimageS} imageL={heroimageL}/>
      <Box>
        <Container maxWidth="lg">
          <Box className="coming-soon" sx={{ padding: "3em 0 3em 0" }}>
            {/* <Typography className="coming-soon">The entourage list is coming soon.</Typography>
            <Typography className="coming-soon">Thanks for your patience! JP & Nadine</Typography> */}
          </Box>
          <Box className="horizontal-line"></Box>
          <Typography className="memo" padding="2em 0 3em 0">A memo for our Entourage</Typography>
          <Typography variant="h3">DRESS CODE</Typography>
          <Box pt="1em" pb="2em">
            <Typography variant="h4" className="position">Female Principal & Secondary Sponsors</Typography>
            <Typography variant="body1">Formal dress in Shades of soft blue, blue-grays, indigos, deep navy & charcoal blue.</Typography>
          </Box>
          <Grid
            container
            justifyContent="center"
            sx={{ px: { xs: '0', lg: '17em', xl: '19em' }}}
            flexWrap="nowrap"
            spacing={{xs: 0, md: 1}}
          >
            <Grid item><Circle color="#A6BBD3"/></Grid>
            <Grid item><Circle color="#8EA0B5"/></Grid>
            <Grid item><Circle color="#5E6578"/></Grid>
            <Grid item><Circle color="#1A3D57"/></Grid>
          </Grid>
          <Box pt="2em" pb="3em">
            <Typography variant="h4" className="position">Male Principal & Secondary Sponsors</Typography>
            <Typography variant="body1">Formal, coat & tie. No Gray colour please.</Typography>
          </Box>
          <Box pb="3em">
            <Typography variant="h4" className="position">Bridesmaids</Typography>
            <Typography variant="body1">Details to be provided by the bride.</Typography>
          </Box>
          <Box pb="5em">
            <Typography variant="h4" className="position">Groomsmen</Typography>
            <Typography variant="body1">Black blazer, black pants, white formal shirt with collar + long sleeves & black shoes. Ties will be provided.</Typography>
          </Box>
          <Box className="horizontal-line"></Box>
          <Typography variant="h3" pt="5em" pb="1em">Wedding Day details</Typography>
          <Box pb="3em">
            <Typography variant="h4" className="position">Principal & Secondary Sponsors</Typography>
            <Typography variant="body1">2:30PM at San Agustin Church for procession line-up. </Typography>
          </Box>
          <Box pb="8em">
            <Typography variant="h4" className="position">Bridesmaids & Groomsmen</Typography>
            <Typography variant="body1">2:15PM - 2:30PM at San Agustin Church for procession line-up. </Typography>
          </Box>
          {/* <Typography className="coming-soon-details" pb="8em">Come back soon for more details.</Typography> */}
        </Container>
      </Box>
      <Box className="sponsors">
        <Container maxWidth="lg">
          <Box pt="8em" pb="10em">
            <Typography variant="h3" className="position">Principal Sponsors</Typography>
            <Grid
              container
              spacing={1}
              sx={{ padding: { xs: '3em 0 0 0', lg: '3em 14em 0 22em', xl: '3em 12em 0 21em' }}}
            >
              {principalSponsors.map(principal => 
              <Grid item xs={12} lg={6}>
                <Typography variant="body1" sx={{ textAlign: {xs: 'center', lg: 'left'}}}>{principal}</Typography>
              </Grid>)}
            </Grid>
          </Box>
          <Box pb="6em">
            <Typography variant="h3" className="position">Secondary Sponsors</Typography>
            <Grid
              container
              spacing={1}
              sx={{ padding: { xs: '3em 0 6em 0', lg: '3em 11em 6em 20em', xl: '3em 11em 6em 20em' }}}
            >
              <Roles title="Candle" col={3} content={candle} />
              <Roles title="Veil" col={3} content={veil} />
              <Roles title="Cord" col={3} content={cord} />
            </Grid>
            <Grid
              container
              spacing={1}
              sx={{ padding: { xs: '1em 0 6em 0', lg: '1em 11em 6em 20em', xl: '1em 11em 6em 20em' }}}
            >
              <Roles title="Bestmen" content={bestMan} />
              <Roles title="Maid of Honors" content={maidOfHonor} />
            </Grid>
            <Grid
              container
              spacing={1}
              sx={{ padding: { xs: '1em 0 6em 0', lg: '1em 11em 6em 20em', xl: '1em 11em 6em 20em' }}}
            >
              <Roles title="Groomsmen" content={groomsmen} />
              <Roles title="Bridesmaids" content={bridesmaids} />
            </Grid>
            <Grid
              container
              spacing={1}
              sx={{ padding: { xs: '1em 0 6em 0', lg: '1em 11em 6em 20em', xl: '1em 11em 6em 20em' }}}
            >
              <Roles title="Junior Groomsmen" content={juniorGroomsmen} />
              <Roles title="Junior Bridesmaids" content={juniorBridesmaids} />
            </Grid>
            <Grid
              container
              spacing={1}
              sx={{ padding: { xs: '1em 0 6em 0', lg: '1em 11em 6em 20em', xl: '1em 11em 6em 20em' }}}
            >
              <Roles title="Bearers" content={bearers} />
              <Roles title="Flower Girls" content={flowerGirls} />
            </Grid>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}